import { render, staticRenderFns } from "./TryTeamio.vue?vue&type=template&id=6620a8c8&scoped=true"
import script from "./TryTeamio.vue?vue&type=script&lang=js"
export * from "./TryTeamio.vue?vue&type=script&lang=js"
import style0 from "./Demo.scss?vue&type=style&index=0&id=6620a8c8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6620a8c8",
  null
  
)

export default component.exports